import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import { DataTableColumnHeader } from "../../components/ui/database-column-header";
import { HiTrash } from "react-icons/hi2";
import { removeUserUploadedDocument } from "../../services/apiUser";
import { useOptimisticRemove } from "../../hooks/useOptimisticRemove";
import { Badge } from "../../components/ui/badge";

function RowActions({ document }) {
  const removeFilterFn = (tempDoc) => {
    return tempDoc.title !== document.title;
  };

  const { mutate } = useOptimisticRemove(
    ["uploadedDocuments"],
    removeUserUploadedDocument,
    removeFilterFn
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0 sticky-col">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuItem
          className="gap-2"
          onClick={() => mutate(document.title)}
        >
          <HiTrash className="text-gray-600" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export const documentUploadColumns = [
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate")
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label="Select all"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: "title",
    headerName: "Title",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title="Title"
        className="w-[400px]"
      />
    ),
    cell: ({ row }) => {
      return <div className="font-medium ">{row.getValue("title")}</div>;
    },
  },
  {
    headerName: "Type",
    accessorKey: "type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Type" />
    ),
  },
  {
    headerName: "Status",
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const status = row.getValue("status");
      if (status === "Done")
        return <Badge variant="success">{row.getValue("status")}</Badge>;
      else if (status === "Processing")
        return <Badge variant="processing">{row.getValue("status")}</Badge>;
      else return <Badge variant="destructive">{row.getValue("status")}</Badge>;
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return <RowActions document={row.original} />;
    },
    className: "sticky-col",
  },
];
